/**
 * /erp/manufacturing — manufacturing job shell (Manager+ only).
 *
 * The router gates this section to manager+ via the API; sales never
 * sees the launcher entry. v1 has a simple list/detail pair with the
 * three-step lifecycle baked into the detail view.
 *
 * The shell is intentionally thin — it only renders an Outlet so the
 * list, "new", and detail pages keep their own headers and breadcrumbs
 * (the detail page especially benefits from showing the job code in
 * the heading rather than a generic "Manufacturing").
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/erp/manufacturing")({
  component: ManufacturingShell,
});

function ManufacturingShell() {
  return <Outlet />;
}
